<template>
  <div
    class="to-top"
    @click="toTop"
  />
</template>

<script>
export default {
  methods: {
    toTop () {
      this.$emit('to_top')
    }
  }
}
</script>

<style lang="scss" scoped>
.to-top {
  width: 32px;
  height: 32px;
  float: right;
  margin-right: 18px;
  text-align: center;
  color: #333333;
  font-size: 12px;
  cursor: pointer;
  margin-bottom: 10px;
  background: url(~@/assets/images/page-to-top.png) no-repeat 0 0;
  &:hover {
    background-position: -32px 0;
  }
  &:active {
    background-position: -64px 0;
  }
}
</style>
